import React from 'react';
import { store } from '../../../../store';
import FontPicker from './FontPicker'
import ColorPicker from './ColorPicker'

class CustomizationPanel extends React.Component {
	render(props) {
		let { customization, activities } = store.getState()
		const removeSelect = () => {
			if(customization.select){
			this.props.onOpen('')
			this.props.onSelectToolbar('')
			}
			return <div className="customizationpanel custom_out">
			</div>
		}
			if(activities.open === 'toolbar')
		return (
			<div className="customizationpanel"
    onMouseOver={this.props.onClickInside.bind()}
    onMouseOut={this.props.onClickOutside.bind()}>
    		<span onClick={()=>this.props.onOpen('')} href="#" className="close closepanel"/>
    		<div className="panel">
    		{customization.select !== 'background'
			? <FontPicker
				onCustomization={this.props.onCustomization}
			/>
			: null
			}
        	<ColorPicker
				onCustomization={this.props.onCustomization}/>
				</div>
			</div>

			)
	else
		return removeSelect()
	}
}
export default CustomizationPanel

